// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c820b0cd","455":"1e7354b6","977":"a925ea0c"}[chunkId] + ".chunk.js";
};